export default "__VITE_ASSET__uvLM8niE__"